import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import ShopPage from "@/pages/ShopPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import PromoPopin from "@/components/PromoPopin";
import BackToTopButton from "@/components/BackToTopButton";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ServicesPage from "@/pages/ServicesPage";
import PromotionsPage from "@/pages/PromotionsPage";
import PricingPage from "./pages/PricingPage";
import PackagesPage from "@/pages/PackagesPage";
import MembershipPage from "@/pages/MembershipPage";
import AboutPage from "@/pages/AboutPage";
import BookingPage from "@/pages/BookingPage";
import CheckoutPage from "@/pages/CheckoutPage";
import GroupBookingPage from "@/pages/GroupBookingPage";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function Layout({ children }) {
    const location = useLocation();
    useEffect(() => { if (!location.hash) window.scrollTo(0, 0); }, [location.pathname, location.hash]);
    const isAuth = location.pathname === "/login" || location.pathname === "/register" || location.pathname === "/forgot-password" || location.pathname === "/reset-password";
    return (
        <div className="App bg-[#FBF6F0]">
            {!isAuth && <Navbar />}
            <main>{children}</main>
            {!isAuth && <Footer />}
        </div>
    );
}

function PromoWrapper() {
    const { user } = useAuth();
    return user ? <PromoPopin user={user} /> : null;
}

function App() {
    return (
        <AppErrorBoundary>
            <AuthProvider>
                <SettingsProvider>
                    <CartProvider>
                        <BrowserRouter>
                            <Layout>
                                <Routes>
                                    <Route path="/" element={<LandingPage />} />
                                    <Route path="/services" element={<ServicesPage />} />
                                    <Route path="/shop" element={<ShopPage />} />
                                    <Route path="/promotions" element={<PromotionsPage />} />
                                    <Route path="/pricing" element={<PricingPage />} />
                                    <Route path="/packages" element={<PackagesPage />} />
                                    <Route path="/membership" element={<MembershipPage />} />
                                    <Route path="/about" element={<AboutPage />} />
                                    <Route path="/book" element={<BookingPage />} />
                                    <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
                                    <Route path="/book/group" element={<ProtectedRoute><GroupBookingPage /></ProtectedRoute>} />
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/register" element={<RegisterPage />} />
                                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                                    <Route path="/dashboard" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
                                    <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
                                </Routes>
                            </Layout>
                            <PromoWrapper />
                            <CartDrawer />
                            <BackToTopButton />
                            <WhatsAppFloat />
                            <Toaster theme="light" position="top-right" toastOptions={{
                                style: { background: "#FFFFFF", border: "1px solid #C29A5B", color: "#3D0C1F", borderRadius: 0 }
                            }} />
                        </BrowserRouter>
                    </CartProvider>
                </SettingsProvider>
            </AuthProvider>
        </AppErrorBoundary>
    );
}

export default App;
